import React, { useRef } from "react";

const PRODUCTS = [
  {
    index: "01",
    name: "慧声有漫",
    en: "AI VIDEO STUDIO",
    badge: { label: "LIVE", kind: "live" },
    desc: "AI 漫剧创作平台。从分镜、角色到配音与剪辑，让每一个故事都拥有被看见的能力。",
    href: "https://aivideo.soundwisdomai.com",
    url: "aivideo.soundwisdomai.com",
    visual: (
      <svg viewBox="0 0 320 140" preserveAspectRatio="none">
        <defs>
          <linearGradient id="gA" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#f0c896" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#5fd3c8" stopOpacity="0.4" />
          </linearGradient>
        </defs>
        <g stroke="url(#gA)" strokeWidth="1" fill="none" opacity="0.85">
          {Array.from({ length: 18 }).map((_, i) => (
            <path
              key={i}
              d={`M0 ${30 + i * 4} Q160 ${30 + i * 4 + (i % 2 ? 18 : -18)} 320 ${
                30 + i * 4
              }`}
            />
          ))}
        </g>
      </svg>
    ),
  },
  {
    index: "02",
    name: "Tapflick",
    en: "INTERACTIVE GAMES",
    badge: { label: "LIVE", kind: "live" },
    desc: "互动游戏平台。一指轻触，剧情即随你而动。把观看与游玩融合为同一种体验。",
    href: "https://tapflick.ai",
    url: "tapflick.ai",
    visual: (
      <svg viewBox="0 0 320 140" preserveAspectRatio="none">
        <defs>
          <radialGradient id="gB" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#5fd3c8" stopOpacity="0.7" />
            <stop offset="100%" stopColor="#5fd3c8" stopOpacity="0" />
          </radialGradient>
        </defs>
        <circle cx="160" cy="70" r="60" fill="url(#gB)" />
        <circle
          cx="160"
          cy="70"
          r="40"
          fill="none"
          stroke="#f0c896"
          strokeWidth="0.8"
          opacity="0.6"
        />
        <circle
          cx="160"
          cy="70"
          r="58"
          fill="none"
          stroke="#f0c896"
          strokeWidth="0.6"
          opacity="0.4"
          strokeDasharray="4 6"
        />
        <circle
          cx="160"
          cy="70"
          r="76"
          fill="none"
          stroke="#5fd3c8"
          strokeWidth="0.5"
          opacity="0.4"
          strokeDasharray="2 8"
        />
        <line
          x1="160"
          y1="20"
          x2="160"
          y2="120"
          stroke="#f5efe6"
          strokeWidth="0.5"
          opacity="0.25"
        />
        <line
          x1="80"
          y1="70"
          x2="240"
          y2="70"
          stroke="#f5efe6"
          strokeWidth="0.5"
          opacity="0.25"
        />
      </svg>
    ),
  },
  {
    index: "03",
    name: "AI 互动影视游戏制作工具",
    en: "INTERACTIVE FILM & GAME ENGINE",
    badge: { label: "SOON", kind: "soon" },
    desc: "面向创作者的一站式 AI 制作工具。从剧本、分镜到互动逻辑与成片输出，把想象直接变成可分发的影游体验。",
    href: null,
    url: "尚未上线 · COMING SOON",
    visual: (
      <svg viewBox="0 0 320 140" preserveAspectRatio="none">
        <defs>
          <linearGradient id="gC" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#d4a574" stopOpacity="0.0" />
            <stop offset="50%" stopColor="#d4a574" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#d4a574" stopOpacity="0.0" />
          </linearGradient>
        </defs>
        {Array.from({ length: 12 }).map((_, i) => (
          <rect
            key={i}
            x={20 + i * 24}
            y={70 - (i % 2 ? 20 : 40)}
            width="14"
            height={i % 2 ? 40 : 80}
            fill="none"
            stroke="url(#gC)"
            strokeWidth="0.8"
            opacity={0.4 + (i % 4) * 0.15}
          />
        ))}
        <line
          x1="0"
          y1="120"
          x2="320"
          y2="120"
          stroke="#d4a574"
          strokeWidth="0.5"
          opacity="0.4"
        />
      </svg>
    ),
  },
];

function ProductCard({ data, idx }) {
  const ref = useRef(null);
  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    el.style.setProperty("--cx", `${e.clientX - r.left}px`);
    el.style.setProperty("--cy", `${e.clientY - r.top}px`);
  };
  const isLink = !!data.href;
  return (
    <article
      ref={ref}
      onMouseMove={onMove}
      className="card"
      data-reveal
      data-reveal-delay={idx + 1}
    >
      <div className="card__head">
        <span className="card__index">{data.index}</span>
        <span className={`card__badge card__badge--${data.badge.kind}`}>
          {data.badge.label}
        </span>
      </div>

      <div className="card__visual">{data.visual}</div>

      <div>
        <h3 className="card__title">{data.name}</h3>
        <div className="card__sub">{data.en}</div>
        <p className="card__desc">{data.desc}</p>
      </div>

      {isLink ? (
        <a
          className="card__link"
          href={data.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>访问</span>
          <span className="url">{data.url}</span>
          <span className="arrow">↗</span>
        </a>
      ) : (
        <span className="card__link card__link--dim">
          <span>状态</span>
          <span className="url">{data.url}</span>
        </span>
      )}
    </article>
  );
}

function Products() {
  return (
    <section id="products" className="section">
      <div className="products__head">
        <div>
          <span className="eyebrow" data-reveal>
            产品矩阵 · PRODUCTS
          </span>
          <h2 className="section-title" data-reveal data-reveal-delay="1">
            三个产品，<em>一个生态</em>。
          </h2>
        </div>
        <p className="section-lede" data-reveal data-reveal-delay="2">
          从生成、互动到工具化封装 —
          慧声搭建覆盖创作者、平台与观众的完整链路，让 AI
          原生内容真正进入消费者的日常。
        </p>
      </div>

      <div className="product-grid">
        {PRODUCTS.map((p, i) => (
          <ProductCard key={p.index} data={p} idx={i} />
        ))}
      </div>
    </section>
  );
}

export default Products;
